import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import InputBlock from './InputBlock';

class InputBlockIcon extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    icon: PropTypes.string
  };

  state = {
    focus: false
  };

  onFocus = () => {
    this.setState({
      focus: true
    });
  };

  onBlur = () => {
    this.setState({
      focus: false
    });
  };

  render() {
    const { className, icon, children, ...props } = this.props;
    const { focus } = this.state;

    const classComponent = classNames(className, { focus });

    return (
      <InputBlock className={classComponent} {...props}>
        <div
          className="input__group__block"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        >
          <div className="icon"> {icon} </div>
          {children}
        </div>
      </InputBlock>
    );
  }
}

export default InputBlockIcon;
